import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { Tooltip } from "@elevate_security/elevate-component-library"
import * as actions from "../../../services/actions"

// Selectors
import { getPageNumber } from "../../../services/selectors/visionSelectors"

// Components
import CardHeader from "../CardHeader/CardHeader"
import HeaderRow from "./HeaderRow"
import TableRow from "./TableRow"
import Icon from "../Icon"
import ErrorState from "../ErrorState/ErrorState"
import Pagination from "../Pagination/Pagination"
import { getPaginatedData } from "../Pagination/Pagination.utils"

const AdvancedScoreChart = props => {
  // Data
  const {
    children,
    title,
    keys,
    getScores,
    childLevel,
    level,
    links,
    departmentHead,
    className,
    pageNumber
  } = props

  // Row Props
  const rowProps = {
    rowSpacing: {
      flex: `1 1 ${Math.floor((1 / keys.length) * 100)}%`,
      minWidth: "7vw"
    },
    keys,
    getScores,
    childLevel,
    links
  }

  const paginationProps = {
    data: children,
    limit: 10,
    totalCount: children.length,
    defaultPage: 1
  }

  const paginationRows = getPaginatedData(children, pageNumber, 10)

  const generateToolTip = data => {
    const firstName = data ? data.split(" ")[0] : ""
    return `${data} is the Head of Department. The row of scores listed next to ${firstName} are specific to this individual.`
  }
  return (
    <div className="card">
      <div className="d-flex p-0">
        <CardHeader
          header={{ title }}
          noBottomBorder="border-bottom-0 mt-2"
          titleSize="h2"
          className={className}
        />
      </div>
      {children[0].id ? (
        <div>
          {level === "department" && departmentHead && (
            <div className="">
              <div className="d-flex flex-row align-items-baseline superior-text">
                <span className="highlight-legend-text">
                  Head of Department:
                </span>
                <span className="margin-left-5 margin-right-5 card">
                  {departmentHead}
                </span>
                <Tooltip
                  body={generateToolTip(departmentHead)}
                  placement="top"
                  readOnly
                >
                  <Icon name="personCircle" />
                </Tooltip>
              </div>
            </div>
          )}
          <div className="mb-0 pt-0 advanced-table demo-advanced-table">
            <HeaderRow {...rowProps} />
            {paginationRows.map(item => (
              <TableRow item={{ ...item }} {...rowProps} key={Math.random()} />
            ))}
          </div>
          <Pagination {...paginationProps} />
        </div>
      ) : (
        <div className="center-text">
          <ErrorState />
        </div>
      )}
    </div>
  )
}

AdvancedScoreChart.propTypes = {
  children: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.any,
      name: PropTypes.string,
      is_manager: PropTypes.bool,
      is_team_manager: PropTypes.bool,
      scores: PropTypes.arrayOf(
        PropTypes.shape({
          key: PropTypes.string,
          scores: PropTypes.shape({
            score: PropTypes.number
          })
        })
      )
    })
  ),
  title: PropTypes.string,
  keys: PropTypes.arrayOf(PropTypes.string),
  getScores: PropTypes.func.isRequired,
  childLevel: PropTypes.string,
  level: PropTypes.string,
  links: PropTypes.bool,
  departmentHead: PropTypes.string,
  className: PropTypes.string,
  pageNumber: PropTypes.number,
  actions: PropTypes.shape({
    getPageNumber: PropTypes.func
  }).isRequired
}

AdvancedScoreChart.defaultProps = {
  children: [{}],
  title: "No Title",
  keys: [],
  childLevel: null,
  level: null,
  links: false,
  departmentHead: null,
  className: "",
  pageNumber: 1
}

const mapStateToProps = state => ({
  pageNumber: getPageNumber(state)
})

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    actions: bindActionCreators(actions, dispatch)
  }
}

// export AdvancedScoreChart
export default connect(mapStateToProps, mapDispatchToProps)(AdvancedScoreChart)
